<nb-card>
  <nb-card-header>
    <div class="form-inline" [formGroup]="diaForm">
      <nb-form-field fullWidth>
        <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
        <input
          type="text"
          nbInput
          fullWidth
          shape="semi-round"
          class="form-control"
          placeholder="Nhập tên mặt hàng"
          formControlName="title"
          [(ngModel)]="strSearch"
          #title
          (change)="onSearch()"
        />
      </nb-form-field>

      <nb-form-field *ngIf="isProduct">
        <input
          type="text"
          nbInput
          shape="semi-round"
          class="form-control"
          style="width: 80px"
          placeholder="ĐVT"
          formControlName="unit"
        />
      </nb-form-field>

      <nb-form-field
        *ngIf="isProduct && (mode === 'receipt' || mode === 'trade')"
      >
        <input
          type="text"
          nbInput
          shape="semi-round"
          class="form-control"
          style="width: 120px"
          placeholder="Giá bán"
          formControlName="price"
          (keydown.enter)="create()"
          [ngxNumberFormat]="formatCurrency"
        />
      </nb-form-field>

      <nb-form-field
        *ngIf="isProduct && (mode === 'receipt' || mode === 'trade')"
      >
        <input
          type="text"
          nbInput
          shape="semi-round"
          class="form-control"
          style="width: 50px"
          placeholder="SL"
          formControlName="quantity"
          (keydown.enter)="create()"
          [ngxNumberFormat]="formatCurrency"
        />
      </nb-form-field>

      <nb-form-field *ngIf="isProduct && mode === 'purchase'">
        <input
          type="text"
          nbInput
          shape="semi-round"
          class="form-control"
          style="width: 120px"
          placeholder="Giá mua"
          formControlName="costPrice"
          (keydown.enter)="create()"
          [ngxNumberFormat]="formatCurrency"
        />
      </nb-form-field>

      <button
        *ngIf="isProduct"
        type="submit"
        nbButton
        hero
        shape="semi-round"
        status="info"
        size="small"
        (click)="create()"
        [disabled]="submitted || !diaForm.valid"
        [class.btn-pulse]="submitted"
      >
        <nb-icon nbPrefix icon="save-outline"></nb-icon>
        {{ "buttons.save" | translate }}
      </button>
    </div>

    <!-- <div *ngIf="categories && categories.length > 0" class="form-inline">
      <div class="container">
        <div class="item" *ngFor="let item of categories; let i = index">
          <a
            (click)="selectCatalog(item)"
            [ngClass]="
              item.id === selectedCatalog
                ? 'text-primary link'
                : 'text-hint link'
            "
          >
            <nb-icon icon="search-outline"></nb-icon>
            {{ item.title }}
          </a>
        </div>

        <div *ngIf="selectedCatalog" class="item">
          <a (click)="selectCatalog(null)" class="text-danger link">
            <nb-icon icon="close-outline"></nb-icon>
            Bỏ lọc
          </a>
        </div>
      </div>
    </div> -->
  </nb-card-header>
  <nb-card-body>
    <nb-list>
      <nb-list-item
        *ngFor="
          let item of display
            | paginate: { itemsPerPage: 10, currentPage: page };
          let i = index
        "
        [ngClass]="i % 2 == 0 ? 'content bg1' : 'content bg2'"
      >
        <div *ngIf="!item.editing" class="summary">
          <div class="title">
            <button
              *ngIf="isProduct && !isEditing"
              nbButton
              ghost
              status="info"
              size="small"
              [disabled]="submitted"
              [class.btn-pulse]="submitted"
              (click)="onEdit(item)"
            >
              <nb-icon icon="edit-2-outline"></nb-icon>
            </button>
            <h6 class="text-body">
              {{ item.title }}

              <span *ngIf="item.unitName" class="text-hint"
                >({{ item.unitName }})</span
              >
            </h6>
          </div>
        </div>

        <div *ngIf="!item.editing" class="button-actions">
          <h6
            *ngIf="mode === 'receipt' || mode === 'trade'"
            class="text-primary"
          >
            {{ item.price | number }}
          </h6>
          <h6 *ngIf="mode === 'purchase'" class="text-primary">
            {{ item.costPrice | number }}
          </h6>
          <button
            nbButton
            shape="round"
            outline
            status="success"
            size="small"
            [disabled]="submitted"
            [class.btn-pulse]="submitted"
            (click)="selected(item)"
          >
            <nb-icon icon="checkmark-outline"></nb-icon>
          </button>
        </div>

        <!-- Edit product-->
        <div *ngIf="item.editing" class="detail-editing">
          <input
            type="text"
            nbInput
            fullWidth
            shape="semi-round"
            class="form-control"
            placeholder="Nhập tên"
            [(ngModel)]="eTitle"
          />

          <div class="form-inline">
            <input
              type="text"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              placeholder="{{ 'product.unit' | translate }}"
              [(ngModel)]="eUnit"
            />
            <input
              *ngIf="mode === 'receipt' || mode === 'trade'"
              type="text"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              placeholder="Nhập giá bán"
              [(ngModel)]="ePrice"
              (keydown.enter)="confirmEdit(item)"
              [ngxNumberFormat]="formatCurrency"
            />
            <input
              *ngIf="mode === 'purchase'"
              type="text"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              placeholder="Nhập giá mua"
              [(ngModel)]="eCostPrice"
              (keydown.enter)="confirmEdit(item)"
              [ngxNumberFormat]="formatCurrency"
            />

            <div class="button-actions">
              <button
                nbPrefix
                nbButton
                outline
                shape="semi-round"
                size="small"
                nbTooltip="Hủy"
                (click)="cancelEdit(item)"
              >
                <nb-icon icon="close-circle-outline"> </nb-icon>
                Hủy
              </button>

              <button
                nbSuffix
                nbButton
                hero
                status="primary"
                shape="semi-round"
                size="small"
                nbTooltip="{{ 'buttons.save' | translate }}"
                (click)="confirmEdit(item)"
              >
                <nb-icon icon="save-outline"> </nb-icon>
                {{ "buttons.save" | translate }}
              </button>
            </div>
          </div>
        </div>
      </nb-list-item>
    </nb-list>
  </nb-card-body>

  <nb-card-footer>
    <pagination-controls (pageChange)="page = $event"></pagination-controls>
  </nb-card-footer>
</nb-card>
